import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { JourneyActionButtonType } from './type';
export const defaultJourneyActionButtonCustomProps = {
    type: JourneyActionButtonType.Custom,
    label: undefined,
    onClick: undefined,
    iconName: undefined,
    className: undefined
};
export const journeyActionButtonCustomPropsValidator = Validator.object({
    type: Validator.isEqualTo(JourneyActionButtonType.Custom),
    label: nonEmptyStringValidator,
    onClick: Validator.fn(),
    iconName: Validator.optional(nonEmptyStringValidator),
    className: Validator.optional(nonEmptyStringValidator)
});
